import MuiFormControl from '@mui/material/FormControl';
import * as React from 'react';
import { IFormControlProps } from './form-control-props';
import './form-control.scss';

export const FormControl: React.FunctionComponent<IFormControlProps> = ({ children, ...props }) => {
  return <MuiFormControl {...props}>{children}</MuiFormControl>;
};
